module.exports = __webpack_public_path__ + "static/img/1.8bd6f80.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/help/1.png
// module id = QwOg
// module chunks = 0